import gql from "graphql-tag"
import fragments from "../gql/fragment"
import { Action, IVariable, TableName } from "Types/table"

// 生成table list query
export const generateQuery = (tableName: TableName, returnValue?: string) => {
    const fragmentName: TableName = tableName
    const fragment = fragments[fragmentName]
    const index = tableName === "users" ? "uid" : "id"
    return gql`
        query ${tableName}_list($limit: Int!, $offset: Int!, $order_by: [${tableName}_order_by!], $where: ${tableName}_bool_exp!) {
            ${tableName}(limit:$limit, offset:$offset, order_by: $order_by, where: $where) {
                ...${tableName}
                ${returnValue === undefined ? "" : returnValue}
            }
            ${tableName}_aggregate(where: $where) {
                aggregate {
                    count(columns: ${index})
                }
            }
        }
        ${fragment}
    `
}
// 生成mutation

export const generateMutation = (
    action: Action,
    tableName: TableName,
    variables: IVariable[],
    returnValue?: string,
    where?: string
) => {
    const fragmentName: TableName = tableName
    const fragment = fragments[fragmentName]
    const index = tableName === "users" ? "uid" : "id"
    const variablesQuery = variables.reduce((acc: string, cur: any) => {
        return `${acc}${acc ? "," : ""}$${cur.name}: ${cur.type}!`
    }, "")
    const whereQuery = action !== "insert" ? where || `where: {${index}: { _eq: $${index}}}` : ""
    const insertQuery = action === "insert" ? `objects: {${variables.reduce((acc: string, cur: any) => {
        return `${acc}${acc ? "," : ""}${cur.name}: $${cur.name}`
    }, "")}}` : ""
    const updateQuery = action === "update" ? `_set: {${variables.reduce((acc: string, cur: any) => {
        if (cur.name === index) {
            return acc
        }
        return `${acc}${acc ? "," : ""}${cur.name}: $${cur.name}`
    }, "")}}` : ""
    return gql`
        mutation ${action}_${tableName} (${variablesQuery}) {
            ${action}_${tableName}(${insertQuery}${insertQuery && whereQuery ? "," : ""} ${whereQuery}${updateQuery ? "," : ""} ${updateQuery}) {
                returning {
                    ...${tableName}
                    ${returnValue === undefined ? "" : returnValue}
                }
            }
        }
        ${fragment}
    `
}


// 生成subscription

export const generateSubscription = (tableName: TableName, returnValue?: string, orderBy?: string) => {
    const fragmentName: TableName = tableName
    const fragment = fragments[fragmentName]
    return gql`
        subscription ${tableName}_list($where: ${tableName}_bool_exp!) {
            ${tableName}(
                where: $where,
                ${orderBy === undefined ? "" : `order_by: ${orderBy}`}
            ) {
                ...${tableName}
                ${returnValue === undefined ? "" : returnValue}
            }
        }
        ${fragment}
    `
}
